export default {
  gameAssets: '遊戲資產', cryptoAssets: '鏈上資產', activity: '紀錄', settings: '設定', main: '主導航'
} as const;
